import axios from "axios";

const location = window.location;

const params = new URLSearchParams(location.search);

let token = params.get("token");
if (!token) {
  token = sessionStorage.getItem("auth_token");
} else {
  sessionStorage.setItem("auth_token", token);
}

const instance = axios.create({
  baseURL: import.meta.env.VITE_BASE_API_URL,
  responseType: "json",
  headers: {
    Authorization: token ? `Bearer ${token}` : "",
  },
});

instance.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default instance;
